import { render, staticRenderFns } from "./CandidateLogTab.vue?vue&type=template&id=3f1587c8&lang=pug"
import script from "./CandidateLogTab.vue?vue&type=script&lang=js"
export * from "./CandidateLogTab.vue?vue&type=script&lang=js"
import style0 from "./CandidateLogTab.vue?vue&type=style&index=0&id=3f1587c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports